import AntIcon from "@/components/icons/AntIcon";
import { Popover } from "antd";
import t from "../../../../../app/i18n";

const RULE_OPTION_NUMBERS = [1, 2, 3, 4, 5, 6];

export const CommissionsSettingsRuleHelperView = () => (
  <Popover
    title={t("commissions.settings.helpers.rules.title")}
    content={
      <ol>
        {RULE_OPTION_NUMBERS.map((optionNumber) => (
          <li key={optionNumber}>{t("commissions.settings.helpers.rules.option" + optionNumber)}</li>
        ))}
      </ol>
    }
  >
    <span>
      <AntIcon type="question" className="cursor-help" style={{ fontSize: "20px" }} />
    </span>
  </Popover>
);
